export default "__VITE_ASSET__4ag0QULc__"